import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import useTeamMembers from "@babackapp/private-api-client/client/use-team-members";
import { ReturnRequestLogDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { MessageCircleIcon } from "lucide-react";
import ActivityContentWrapper from "./activity-content-wrapper";
import ActivityIconWrapper from "./activity-icon-wrapper";
import { ActivityItemHeader } from "./activity-item-header";
import ActivityWrapper from "./activity-wrapper";
import { getAuthorName } from "@/pages/(app)/returns/utils/get-author-name.ts";

type CommentActivityProps = {
  activity: ReturnRequestLogDto;
};

export default function CommentActivity({ activity }: CommentActivityProps) {
  const t = useTranslation();

  const { data: shop } = useCurrentShopSuspense();
  const { data: members } = useTeamMembers(shop.id);

  const author = getAuthorName(
    members?.find((m) => m.userId === activity.author)?.user,
  );

  return (
    <ActivityWrapper>
      <ActivityIconWrapper>
        <MessageCircleIcon className="size-4" />
      </ActivityIconWrapper>
      <ActivityContentWrapper>
        <ActivityItemHeader
          title={t("returnDetail.newNote")}
          timestamp={activity.date}
        />
        <div className="bg-muted rounded-2xl rounded-bl-none border border-border flex-1 min-w-[400px] p-2 flex gap-2">
          <div className="flex items-center justify-center bg-primary w-4 h-4 rounded-full">
            <span className="text-xs text-primary-foreground scale-75">
              {author?.charAt(0).toUpperCase()}
            </span>
          </div>
          <div className="pt-0 -mt-2">
            <span className="text-[11px] text-muted-foreground">{author}</span>
            <p className="font-medium mt-2 text-xs">{activity.comment}</p>
          </div>
        </div>
      </ActivityContentWrapper>
    </ActivityWrapper>
  );
}
